import { matchSorter } from "match-sorter";

export class ChatAutocomplete {
    input = null;
    dropdown = null;
    mirrorText = null;
    mirrorWord = null;
    submitCallback = null;
    submitCallbackContext = null;
    options = new Map();
    matches = [];
    highlightIndex = 0;

    constructor(input, className, submitCallback, submitCallbackContext) {
        this.input = input;
        this.submitCallback = submitCallback;
        this.submitCallbackContext = submitCallbackContext;

        this.dropdown = $(`<div class='autocompleteDropdown ${className}'></div>`);
        this.mirrorText = $("<span></span>");
        this.mirrorWord = $("<span></span>");
        this.input.after(this.dropdown, $("<div class='autocompleteMirror'></div>").append(this.mirrorText, this.mirrorWord));

        this.dropdown.on("mouseover", "div", event => {
            this._highlight($(event.currentTarget).index());
        });

        this.dropdown.on("mousedown", "div", event => {
            this._highlight($(event.currentTarget).index());
            this.submitCallback(this.submitCallbackContext, event);
        });

        this.hide();
    }

    addOption(key, symbol, label, lifetime) {
        this.options.set(key, { symbol, label, expiry: Date.now() + lifetime });
    }

    removeOption(key) {
        this.options.delete(key);
    }

    clearOptions() {
        this.options.clear();
        this.matches = [];
        this.dropdown.empty();
    }

    setSearchTerm(searchTerm) {
        const now = Date.now();
        for (const [key, option] of this.options) {
            if (now > option.expiry) {
                this.options.delete(key);
            }
        }

        this.matches = matchSorter([...this.options.keys()], searchTerm, {
            keepDiacritics: true,
            baseSort: (first, second) => first.rankedValue.length - second.rankedValue.length || first.rankedValue.localeCompare(second.rankedValue)
        });
        this.dropdown[0].replaceChildren(...this.matches.map(key => {
            const option = this.options.get(key);
            return $("<div></div>").append($("<span class='symbol'></span>").text(option.symbol), $("<span class='label'></span>").text(option.label))[0];
        }));
        this._highlight(0);
        this.dropdown.scrollTop(0);
    }

    getHighlightedMatch() {
        return this.matches[this.highlightIndex] ?? null;
    }

    navigate(shift) {
        if (this.matches.length === 0) {
            return;
        }

        this._highlight((this.highlightIndex + shift + this.matches.length) % this.matches.length);
        this.dropdown.children(".highlight")[0].scrollIntoView({ behavior: "instant", block: "nearest" });
    }

    show() {
        this.dropdown.show();
    }

    hide() {
        this.dropdown.hide();
    }

    isShowing() {
        return this.dropdown.is(":visible");
    }

    updatePosition(labelStart, labelEnd) {
        this.mirrorText.text(this.input.val().slice(0, labelStart));
        this.mirrorWord.text(this.input.val().slice(labelStart, labelEnd));

        const [mirrorWordElement] = this.mirrorWord;
        const wordLeft = mirrorWordElement.offsetParent.offsetLeft + mirrorWordElement.offsetLeft;
        const marginLeft = wordLeft - this.dropdown.find(".label")[0].offsetLeft;

        this.dropdown.css({ "margin-left": `${marginLeft}px`, "margin-top": `${this.input.outerHeight() + 7}px` });
    }

    _highlight(index) {
        this.highlightIndex = index;
        this.dropdown.children().removeClass("highlight").eq(index).addClass("highlight");
    }
}
